import { FC } from 'react';
import styled from '@emotion/styled';
import { Button } from 'components/core/button';
import { Text } from 'components/core/text';
import { H3 } from 'components/core/text/Text';
import { spacing } from 'components/core/theme';
import { mediaMobile } from 'components/core/theme/breakpoints';
import EligibilityFailed from 'public/assets/img/eligibility/failed-check.gif';

import { H4 } from './styles';

export enum EligibilityErrorType {
  ChildNotInPlan,
  Generic,
}

interface Props {
  error?: EligibilityErrorType;
  tryAgain: () => void;
  doNotCheckEligibility: () => void;
}

const getErrorMessage = (error: EligibilityErrorType) => {
  switch (error) {
    case EligibilityErrorType.ChildNotInPlan:
      return (
        <div className="flex flex-col gap-4 pt-4">
          <H4>{'Shoot!'}</H4>
          <Text>{'Looks like your child is not included on your plan.'}</Text>
          <Text variant="heading4">{"We're sorry about that."}</Text>
          <Text variant="heading4">
            {'Would you like to edit your insurance information and try again?'}
          </Text>
          <Text variant="heading4">
            {'Keep in mind there is still an option to pay yourself.'}
          </Text>
        </div>
      );
    case EligibilityErrorType.Generic:
      return (
        <div className="flex flex-col gap-4 pt-4">
          <H3>Shoot! Something didn&apos;t work.</H3>
          <Text>
            We&apos;re sorry about that. Would you like to edit your insurance
            information and try again? If not, you can pay for care using a
            credit card.
          </Text>
        </div>
      );
  }
};

const CoverImage = styled.img`
  width: 100%;
  max-width: 434px;
  height: 383px;
  margin: auto;
  object-fit: cover;
  object-position: center;
`;

const Wrapper = styled.div`
  max-width: 720px
  margin: 0 auto;
  text-align: center;

  ${mediaMobile} {
    padding: 0 16px;
  }
`;
const InnerWrapper = styled.div`
  diplay: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacing.s} 0;
  width: 100%;
`;

export const EligibilityError: FC<Props> = ({
  error,
  tryAgain,
  doNotCheckEligibility,
}) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <CoverImage src={EligibilityFailed} />
        {getErrorMessage(error ?? EligibilityErrorType.Generic)}
        <Footer className="flex flex-col">
          <div className="mb-4">
            <Button onClick={tryAgain}>Try Again</Button>
          </div>
          <div className="mb-12">
            <Button variant="secondary" onClick={doNotCheckEligibility}>
              Pay without insurance
            </Button>
          </div>
        </Footer>
      </InnerWrapper>
    </Wrapper>
  );
};
